import { IStore } from '../../index';
import { IRoundTeesAssignation } from '../store';

const removeRoundTee = async (state: IStore, teeAssignationId: number) => {
  const assignation: IRoundTeesAssignation[] = state.roundTees.assignation.filter(
    f => f.id !== teeAssignationId
  );

  return { roundTees: { assignation } };
};

export default removeRoundTee;
